import { AppRoutes } from './app/router';

/**
 * Main App Component
 * Routes are defined in app/router/routes.tsx
 */
function App() {
  return <AppRoutes />;
}

export default App;

